import { DATE_TIME_FORMATS } from "constant";
import { ReportItemSummaryType, NullableNumber, ReportEdgeItem } from "types/Reports";

import ReportAverageText from "./ReportAverageText";
import ReportOUCEdgeText from "./ReportOUCEdgeText";
import ReportPercentText from "./ReportPercentText";

type ReportOUCPartialDescriptionProps = {
    itemType: ReportItemSummaryType;
    inputPercent: NullableNumber;

    numberOfItems: number;
    selectedMonth: moment.Moment;
    dateFormat: string;

    highestItem: ReportEdgeItem;
    lowestItem: ReportEdgeItem;

    unit: string;
    average: NullableNumber;
    prevAverage: NullableNumber;
};

// The full name should be Report Overall Usage Card Partial Description
export default function ReportOUCPartialDescription({
    itemType,
    inputPercent,

    numberOfItems,
    selectedMonth,
    dateFormat,

    highestItem,
    lowestItem,

    unit,
    average,
    prevAverage,
}: Readonly<ReportOUCPartialDescriptionProps>) {
    return <>
        <ReportPercentText
            percent={inputPercent}
            itemType={itemType}
        />

        <ReportOUCEdgeText
            isHighest={true}
            dateFormat={dateFormat}
            numberOfItems={numberOfItems}
            item={highestItem}
            itemType={itemType}
            unit={unit}
        />

        { itemType !== 'waterLeakage' && <ReportOUCEdgeText
            isHighest={false}
            dateFormat={dateFormat}
            numberOfItems={numberOfItems}
            item={lowestItem}
            itemType={itemType}
            unit={unit}
        />}

        { itemType !== 'waterLeakage' && <ReportAverageText
            itemType={itemType}
            average={average}
            prevAverage={prevAverage}
            unit={unit}
            selectedMonth={selectedMonth.format(DATE_TIME_FORMATS.MONTH_ONLY)}
        />}
    </>;
};
